// import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]
const state = {}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getIssueDetail ({commit, state}, params) {
    let promised = request.alert('getIssueDetail', params)
    return promised
  },
  getIssueLogs ({commit, state}, params) {
    let promised = request.alert('getIssueLogs', params)
    return promised
  },
  createIssue ({commit, state}, params) {
    let promised = request.alert('createIssue', params)
    return promised
  },
  updateIssueUser ({commit, state}, params) {
    let promised = request.alert('updateIssueUser', params)
    return promised
  },
  updateIssueOpen ({commit, state}, params) {
    let promised = request.alert('updateIssueOpen', params)
    return promised
  },
  updateIssueFinish ({commit, state}, params) {
    let promised = request.alert('updateIssueFinish', params)
    return promised
  },
  updateIssueFinishAndOrderNotPassed ({commit, state}, params) {
    let promised = request.alert('updateIssueFinishAndOrderNotPassed', params)
    return promised
  },
  updateIssueWait ({commit, state}, params) {
    let promised = request.alert('updateIssueWait', params)
    return promised
  },
  addIssueComment ({commit, state}, params) {
    let promised = request.alert('addIssueComment', params)
    return promised
  },
}

// mutations
const mutations = {}

export const issue = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/issue/issue.store.js